@import '../../scss/use-bootstrap-mixins.scss';

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 24px 24px;
  overflow-y: auto;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.modal {
  background: #111;
  color: #f2f2f2;
  border: 1px solid #333;
  border-radius: 12px;
  width: 100%;
  max-width: 960px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 80px);
}

.header {
  padding: 16px 20px 8px;
  border-bottom: 1px solid #222;
  .title { margin: 0 0 4px; font-size: 20px; font-weight:600; }
  .meta { font-size: 12px; opacity: 0.75; display:flex; gap:12px; flex-wrap:wrap; }
  .saved { color: #4caf50; }
}

.body {
  padding: 12px 20px 20px;
  overflow-y: auto;
  flex: 1;
}

.label { display:flex; flex-direction:column; gap:6px; font-size: 13px; }

.textarea {
  width: 100%;
  min-height: 420px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  background: #1b1b1b;
  color: #e6e6e6;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 12px;
  resize: vertical;
  tab-size: 2;
}

.footer {
  padding: 12px 20px 20px;
  display:flex; gap: 12px; flex-wrap:wrap;
  border-top: 1px solid #222;
}

.btn {
  background: #2d2d2d;
  color: #f3f3f3;
  border: 1px solid #444;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  &:hover { background:#383838; }
  &:active { background:#444; }
}

.error { color: #ff6b6b; font-size: 12px; margin-top: 8px; }
